import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import React from "react";
import Spinner from "@ui/Spinner";

interface P {
  withSpinner?: boolean;
}

const StyledBannerTitle = styled.p`
  align-items: center;
  display: flex;
  font-size: inherit;
`;

const StyledBannerSpinner = css`
  margin-right: 5px;
`;

function BannerTitle({ withSpinner = false, children }: P & React.PropsWithChildren) {
  return (
    <StyledBannerTitle>
      {withSpinner && <Spinner className={StyledBannerSpinner} width={14} height={14} />}
      <span>{children}</span>
    </StyledBannerTitle>
  );
}

export default React.memo(BannerTitle);
